import styles from "./Delimiter.module.scss";

export const Delimiter = () => <hr className={styles.fieldGroupDelimiter} />;
